import { RequestPost } from '../apiClient/api/RequestService';
import {LoginType} from '../utils/status';

function loginStart(){
    return {type : "LOGIN"}
}

function loginSuccess(data, phone, token, refresh_token, type){
    return {type : "LOGIN_SUCCESS", data: data, phone: phone, token: token, refresh_token: refresh_token,loginType: type}
}

function loginFail(message, type){
    return {type : type === 0 ? "LOGIN_TOKEN_FAIL" : "LOGIN_ACCOUNT_FAIL", message: message}
}

export function login(phone,password){
    const content = {
        phone: phone,
        password: password,
    }
    return async dispatch => {
        dispatch(loginStart())
        const res = await RequestPost('/v1/account/login', content)
        
        if (res?.return_code === 1) {
            dispatch(loginSuccess(res.data, phone, res.data.token, res.data.refresh_token, LoginType.Account));
        } 
        else if (res.err === -1) {
            return dispatch(loginFail("Phát sinh lỗi hệ thống. Quý khách vui lòng đăng nhập lại sau",1))
        }
        else {
            dispatch(loginFail("Thông tin đăng nhập không hợp lệ",1))
        }
    }
}

export function loginByToken(token){
    const content = {
        cashier_token: token
    }
    return async dispatch => {
        dispatch(loginStart())
        const res = await RequestPost('/v1/account/token-login', content)

        if (res?.return_code === 1) {
            dispatch(loginSuccess(res.data, res?.data?.merchant?.alias, res.data.token, res.data.refresh_token, LoginType.Token));
        } 
        else if (res.err === -1) {
            return dispatch(loginFail("Phát sinh lỗi hệ thống. Quý khách vui lòng đăng nhập lại sau",0))
        }
        else {
            dispatch(loginFail("Thông tin đăng nhập không hợp lệ",0))
        }
    }
}
